import React from "react";
import {
    AccountingIcon,
    CreditCardIcon,
    IntegrationsIcon,
    LockIcon,
    MailIcon,
    MembersIcon,
    TasksIcon,
    PlansIcon,
    ReceiptIcon,
} from "@icons";
import { NavigationMenu } from "@design-system/Navigation/NavigationMenu";
import { NavigationItem } from "@design-system/Navigation/NavigationItem";
import { WorkspaceSettingsPages } from "./constants";
import { SettingsNavLink } from "./SettingsNavLink";
import { useDocumentInboxSettingsLabel } from "./WorkspaceReceipts/useCanShowBillInvoiceInbox";

export const WorkspaceSettingsNavigation: React.FC = () => {
    const documentInboxLabel = useDocumentInboxSettingsLabel();

    return (
        <>
            <header className="settings__navigation__workspaces-header">
                Workspace
            </header>

            <NavigationMenu className="flex-column">
                <SettingsNavLink eventKey={WorkspaceSettingsPages.MEMBERS}>
                    <NavigationItem icon={<MembersIcon />}>
                        Members
                    </NavigationItem>
                </SettingsNavLink>

                <SettingsNavLink eventKey={WorkspaceSettingsPages.TASK_GROUPS}>
                    <NavigationItem icon={<TasksIcon />}>
                        Task groups
                    </NavigationItem>
                </SettingsNavLink>

                <SettingsNavLink eventKey={WorkspaceSettingsPages.INTEGRATIONS}>
                    <NavigationItem icon={<IntegrationsIcon />}>
                        Integrations
                    </NavigationItem>
                </SettingsNavLink>

                <SettingsNavLink eventKey={WorkspaceSettingsPages.LOCKS}>
                    <NavigationItem icon={<LockIcon />}>Locks</NavigationItem>
                </SettingsNavLink>

                <SettingsNavLink eventKey={WorkspaceSettingsPages.ACCOUNTING}>
                    <NavigationItem icon={<AccountingIcon />}>
                        Accounting
                    </NavigationItem>
                </SettingsNavLink>

                <SettingsNavLink eventKey={WorkspaceSettingsPages.PLANS}>
                    <NavigationItem icon={<PlansIcon />}>Plans</NavigationItem>
                </SettingsNavLink>

                <SettingsNavLink eventKey={WorkspaceSettingsPages.BILLING}>
                    <NavigationItem icon={<CreditCardIcon />}>
                        Billing
                    </NavigationItem>
                </SettingsNavLink>

                <SettingsNavLink
                    eventKey={WorkspaceSettingsPages.BILLING_TRANSFER}
                >
                    <NavigationItem icon={<CreditCardIcon />}>
                        Billing
                    </NavigationItem>
                </SettingsNavLink>

                <SettingsNavLink
                    eventKey={WorkspaceSettingsPages.DOCUMENT_INBOX}
                >
                    <NavigationItem icon={<ReceiptIcon />}>
                        {documentInboxLabel}
                    </NavigationItem>
                </SettingsNavLink>

                <SettingsNavLink
                    eventKey={WorkspaceSettingsPages.SENDING_DOMAINS}
                >
                    <NavigationItem icon={<MailIcon />}>
                        Sending domains
                    </NavigationItem>
                </SettingsNavLink>
            </NavigationMenu>
        </>
    );
};
